import type { ArmyPaint } from '../../../lib/core/ArmyPainter/ArmyPaint.type'
import { getAuthArmyPaintCollection, setAuthArmyPaintCollection } from './AuthArmyPaintCollectionSignal'

export default function deleteArmyPaintToDisk(ap: ArmyPaint) {
  const collection = getAuthArmyPaintCollection()
  setAuthArmyPaintCollection({
    ...collection,
    data: [...collection.data.filter(row => row.id !== ap.id)]
  })
}
